import React from "react";
import { intl } from "LocaleWrapper";

import { Card, PageHeader } from "@cofano/cck";
import { Stack, Tab, Tabs } from "@mui/material";

import useTabs from "components/hooks/useTabs";
import Helmet from "components/helmet/Helmet";

import { Language } from "imports/Utils";

import AdminSettings from "./components/settings/AdminSettings";
import AdminTrigger from "./components/trigger/AdminTrigger";
import AdminLanguage from "./components/language/AdminLanguage";
import AdminNavigation from "./components/navigation/AdminNavigation";
import AdminSupport from "./components/support/AdminSupport";

import { AdminTab } from "./utils/admin.types";

const Admin = () => {

	const { selectedTab, selectTab } = useTabs<AdminTab>({
		defaultSelected: AdminTab.Settings,
	});

	return (
		<React.Fragment>
			<PageHeader>
				<PageHeader.Title>
					{Language("ADMIN_PANEL_TITLE")}
					<Helmet title={intl.formatMessage({ id: "ADMIN_PANEL_TITLE" })} />
				</PageHeader.Title>
			</PageHeader>

			<Stack spacing={2}>
				<Card disablePadding>
					<Tabs
						value={selectedTab}
						indicatorColor="primary"
						scrollButtons="auto"
						onChange={(_, value) => selectTab(value)}
						variant="scrollable">
						<Tab label='Settings' value={AdminTab.Settings} />
						<Tab label='Trigger' value={AdminTab.Trigger} />
						<Tab label='Language' value={AdminTab.Language} />
						<Tab label='Navigation' value={AdminTab.Navigation} />
						<Tab label='Support' value={AdminTab.Support} />
					</Tabs>
				</Card>

				{selectedTab === AdminTab.Settings && <AdminSettings />}
				{selectedTab === AdminTab.Trigger && <AdminTrigger />}
				{selectedTab === AdminTab.Language && <AdminLanguage />}
				{selectedTab === AdminTab.Navigation && <AdminNavigation />}
				{selectedTab === AdminTab.Support && <AdminSupport />}
			</Stack>
		</React.Fragment>
	);
};

export default Admin;

